import {FC} from "react";
import {TransactionMainComponent} from "../../../components";
import {DailyTransactionTypeEnum, PageEnum} from "../../../models";

export const SalesRefundPage: FC = ({}) => {
    //#region html
    return (
        <>
            <TransactionMainComponent
                formId={PageEnum.ReturnSalesBill}
                transactionType={DailyTransactionTypeEnum.SalesRefund}
            />
        </>
    );
    //#endregion
};
